import { UtcZone } from '@unistocks/shared/utils/date-utils';
import { DateRange, TimePeriod } from '@unistocks/types';
import { DateTime } from 'luxon';

/**
 * Start and end of the period (in UTC) containing the given timestamp.
 * The end is clamped to the start of the day so a day timestamp is always the
 * date, not including the time part.
 */
export const getPeriodBounds = (timestamp: number, groupBy: TimePeriod): DateRange => {
  // Built directly from millis: createDate truncates every input to the local
  // start-of-day, which would drop the time component this grouping needs.
  const date = DateTime.fromMillis(timestamp, { zone: UtcZone });
  const startOfPeriod = date.startOf(groupBy);
  const endOfPeriod = date.endOf(groupBy).startOf('day');

  return [startOfPeriod, endOfPeriod];
};

/**
 * Start of the period (in UTC) containing the given timestamp, in millis.
 * Used both as the grouping key and to fetch/slice a range from the period
 * start, so the first period's data stays available even when the selected
 * range starts mid-period (e.g. monthly bars when the range starts Aug 14).
 */
export const getPeriodStart = (timestamp: number, groupBy: TimePeriod): number =>
  getPeriodBounds(timestamp, groupBy)[0].toMillis();

/**
 * End of the period (in UTC) containing the given timestamp, in millis.
 */
export const getPeriodEnd = (timestamp: number, groupBy: TimePeriod): number =>
  getPeriodBounds(timestamp, groupBy)[1].toMillis();
